import { useState, useEffect } from 'react'
import * as actions from '@actions'
import CustomModal from '@/components/shared/CustomModal/CustomModal'
import ModalHeader from '@/components/shared/CustomModal/ModalHeader'
import ModalBody from '@/components/shared/CustomModal/ModalBody'
import ModalFooter from '@/components/shared/CustomModal/ModalFooter'
import {
    PURCHASE_TYPE_PROCESS_DOCUMENT,
} from '@/constants'
import usePayments from '@hook/usePayments'
import PaymentRequiredFlow from '@components/shared/Dialogs/PaymentRequiredDialog/PaymentRequiredFlow'
import useNavigate from '@/hook/useNavigate'
import { toast } from 'react-toastify'
import * as store from '@/store'
import { useWireValue } from '@forminator/react-wire'

const ProcessDocumentsModal = ({ 
    showState,
    vm,
}) => {
    const [show, setShow] = showState
    const [isDoNotPromptToProcessChecked, setIsDoNotPromptToProcessChecked] = useState(false)
    const [hasInsufficientBalance, setHasInsufficientBalance] = useState(false)
    const [showPaymentInnerModal, setShowPaymentInnerModal] = useState(false)
    const navigate = useNavigate()
    const remoteConfig = useWireValue(store.remoteConfig)
    
    const payments = usePayments()
    
    const closeModal = () => {
        setShow(false)
    }
    
    const handleProcessDocument = async () => {
        
        try {
            await actions.queueDocumentForProcessing(vm.record.id, undefined, 1, payments.fundingSource)
            actions.forgetHasPromptedToProcessDocumentId(vm.record.id)
            navigate.toCollectionDetailActiveTab(vm.record.collectionId, 'browse')
            
            toast.success('Queued document for processing')
            if (!remoteConfig?.realtimeEnabled) await actions.updateLocalCredits()
            
        } catch (e) {
            toast.error('Failed to process document')
            // NOOP
        }
        
    }
    
    const handleCancelModal = () => {
        closeModal()
        if (isDoNotPromptToProcessChecked) actions.rememberHasPromptedToProcessDocumentId(vm.record.id)
    }
    
    useEffect(() => {
        setShowPaymentInnerModal(payments.shouldShowPurchaseDialog(
            PURCHASE_TYPE_PROCESS_DOCUMENT,
            1,
        ))
    }, [vm.record.id])
    
    return (
        <CustomModal
            open={show}
            modalHandler={closeModal}
            center>
            <ModalHeader>Process document</ModalHeader>
            <ModalBody>
                <>
                    <p className="pb-3">
                        This document has not been processed. Processing is required for enhanced text 
                        detection in labels, would you like to process it now?
                    </p>
                    
                    {showPaymentInnerModal ? 
                        (
                            <>
                                <hr className="mt-4" />
                                <div className="PaymentRequiredDialog max-w-full mt-4">
                                    <PaymentRequiredFlow
                                        payments={payments}
                                        purchaseType={PURCHASE_TYPE_PROCESS_DOCUMENT}
                                        itemCount={1}
                                        onInsufficientBalanceChange={setHasInsufficientBalance} />
                                </div>
                            </>
                        ) : null  
                    }
                </>
            </ModalBody>
            
            <ModalFooter className="!justify-between">
                <div className="flex flex-row items-center">
                    <label className="flex items-center mr-1">
                        <input
                            type="checkbox"
                            className="checkbox checkbox-info checkbox-sm mr-2"
                            checked={isDoNotPromptToProcessChecked}
                            onChange={e => setIsDoNotPromptToProcessChecked(e.target.checked)}/>
                        <span>Do not ask for this document again</span>
                    </label>
                </div>
                <div className="flex justify-end">
                    <button
                        type="button"
                        className="mr-3 btn btn-primary btn-outline"
                        onClick={handleCancelModal}>
                        Cancel
                    </button>
                    <button 
                        className="btn btn-primary"
                        onClick={handleProcessDocument}
                        disabled={hasInsufficientBalance}>
                        Process
                    </button>
                </div>
            </ModalFooter>
        </CustomModal>
    )
}

export default ProcessDocumentsModal
